import React, { useMemo } from 'react';
import { FadeContent } from '@anton.bobrov/react-components';

const SlideFadeContent = ({
  className,
  style,
  activeKey: activeKeyProp,
  children: childrenProp,
  duration
}) => {
  const activeKey = `${activeKeyProp}`;
  const children = useMemo(
    () => childrenProp.map((child, index) => ({
      key: `${child.props["data-key"] || child.key || index}`,
      children: child
    })),
    [childrenProp]
  );
  return /* @__PURE__ */ React.createElement(
    FadeContent,
    {
      className,
      style,
      activeKey,
      content: children,
      duration
    }
  );
};

export { SlideFadeContent };
//# sourceMappingURL=index.js.map
